type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/**
 * YouTube theater-mode glyph — a wide rounded rectangle with vertical end
 * bars suggesting a widescreen letterboxed canvas. Visual-only in the
 * safe-zone overlay (theater mode is a YouTube-DOM concern that doesn't
 * apply inside the preview iframe).
 */
const YouTubeTheaterIcon = (props: Props) => {
  const { width = '20', height = '14', strokeColor = '#ffffff' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      aria-hidden
    >
      <rect
        x="1"
        y="2.5"
        width="18"
        height="9"
        rx="1.4"
        stroke={strokeColor}
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
};

export default YouTubeTheaterIcon;
